import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import './SignUp.css';
import useMetaMask from '../../hooks/metamask';
import InputFile from '../../components/inputFile/InputFile';
import notify from '../../utils/notify';

const textOnlyRegex = new RegExp(/^([a-zA-Z]+\s)*[a-zA-Z]+$/);
const numberOnlyRegex = new RegExp(/^[0-9]+$/);

const signUpSchema = yup.object({
    name: yup
        .string()
        .required('Please enter name.')
        .matches(textOnlyRegex, 'Enter a valid name.')
        .min(2, 'Name must be at least 2 characters long.')
        .max(20, 'Name should not be more than 20 characters.'),
    email: yup.string().email('Please enter a valid Email').required('Please enter email.'),
    mobileNumber: yup
        .string()
        .required('Please enter mobile number.')
        .matches(numberOnlyRegex, 'Mobile number must contain numbers only.')
        .min(7, 'Phone must be at least 7 character long.')
        .max(14, 'Phone should not be more than 14 characters.'),
    password: yup.string().required('Please enter password.').min(8, 'Password must be at least 8 character long.'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match.'),
});

const SignUp = () => {
    const { account } = useMetaMask();
    const [profileImg, setProfileImg] = useState(null);
    const [showProfileImgError, setShowProfileImgError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm({
        resolver: yupResolver(signUpSchema),
    });

    const togglePasswordHandler = () => {
        setShowPassword((prev) => !prev);
    };

    const toggleConfirmPasswordHandler = () => {
        setShowConfirmPassword((prev) => !prev);
    };

    useEffect(() => {
        setShowProfileImgError(false);
    }, [profileImg]);

    const submitHandler = (submittedData) => {
        console.log(submittedData);
        const formData = new FormData();
        formData.append('name', submittedData.name);
        formData.append('email', submittedData.email);
        formData.append('mobileNumber', submittedData.mobileNumber);
        formData.append('address', account);
        formData.append('password', submittedData.password);
        formData.append('confirmPassword', submittedData.confirmPassword);
        if (profileImg) {
            formData.append('profilePic', profileImg);
            axiosInstance
                .post(endpoints.signup, formData)
                .then((res) => {
                    window.location.reload();
                })
                .catch((error) => {
                    notify(error.response.data.Message);
                });
        } else {
            setShowProfileImgError(true);
        }
    };

    return (
        <div className="form-wrapper">
            <form onSubmit={handleSubmit(submitHandler)}>
                <div className="inner-form-wrap">
                    <div className="form-block">
                        <label>name*</label>
                        <input {...register('name')} type="text" placeholder="name" className="form-control" />
                        {errors.name && <span className="error-msg">{errors.name.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>email*</label>
                        <input {...register('email')} type="text" placeholder="email" className="form-control" />
                        {errors.email && <span className="error-msg">{errors.email.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>mobile number*</label>
                        <input {...register('mobileNumber')} type="text" placeholder="mobile number" className="form-control" />
                        {errors.mobileNumber && <span className="error-msg">{errors.mobileNumber.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>Address</label>
                        <input readonly value={account} type="text" placeholder="Address" className="form-control" />
                        {errors.address && <span className="error-msg">{errors.address.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>password*</label>
                        <div className="passwrd-block">
                            <input
                                {...register('password')}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="password"
                                className="form-control"
                            />
                            <i
                                style={{ cursor: 'pointer' }}
                                onClick={togglePasswordHandler}
                                className={`icon-eye ${showPassword ? 'active' : ''}`}
                            ></i>
                        </div>
                        {errors.password && <span className="error-msg">{errors.password.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>confirm password*</label>
                        <div className="passwrd-block">
                            <input
                                {...register('confirmPassword')}
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="confirm password"
                                className="form-control"
                            />
                            <i
                                style={{ cursor: 'pointer' }}
                                onClick={toggleConfirmPasswordHandler}
                                className={`icon-eye ${showConfirmPassword ? 'active' : ''}`}
                            ></i>
                        </div>
                        {errors.confirmPassword && <span className="error-msg">{errors.confirmPassword.message}</span>}
                    </div>
                    <div className="file-upload">
                        <div className="form-block">
                            <label>profile image</label>
                            <InputFile onImageUpload={setProfileImg} />
                            {showProfileImgError && <span className="error-msg">Please upload image.</span>}
                            {/* <div className="file-img-wrapper">
                                <div className="img-upload">
                                    <img src={uploadImg} alt="name-img" />
                                </div>
                                <input type="file" id="nameImage" className="img-file" />
                                <label className="img-file" htmlFor="nameImage"></label>
                                <button className="cross-btn"></button>
                            </div> */}
                        </div>
                        {/* <div className="form-block">
                            <label>banner image</label>
                            <InputFile onImageUpload={setBannerImg} />
                        </div> */}
                    </div>
                    <button type="submit" className="btn-main">
                        Sign Up
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SignUp;
